import { combineReducers } from "redux";
import collections from "./collections.reducers";

const collectionsReducers = combineReducers({
  collections
});

export default collectionsReducers;
